'use client';

import { BookAppointmentWidget } from './BookAppointmentWidget';

export function BookAppointmentWidgetC(
  props: React.ComponentProps<typeof BookAppointmentWidget>,
) {
  return <BookAppointmentWidget {...props} />;
}
